import { FEATURE_FLAGS_NAMES, SENSORS_MAP } from '@linearb/linjs-common';
import useFF from 'common/hooks/settings/useFF';
import { isSensorOAuth2 } from 'common/services/sensors.service';
import { useMemo } from 'react';

const SUPPORTED_OAUTH2_PROVIDERS = [SENSORS_MAP.JIRA];

const mapSensorIdToFF = {
  [SENSORS_MAP.JIRA]: FEATURE_FLAGS_NAMES.isJiraOAuth2Enabled
};

const useIsSensorSupportOAuth2 = sensor => {
  const ffName = mapSensorIdToFF[sensor?.sensor_id];
  const ffValue = useFF(ffName);

  const isSupport = useMemo(() => {
    const isSupportOAuth2 = SUPPORTED_OAUTH2_PROVIDERS.includes(
      sensor?.sensor_id
    );
    const isCloud = !sensor?.is_self_hosted;
    const isOAuth2 = isSensorOAuth2(sensor);

    return (ffValue && isCloud && isSupportOAuth2) || isOAuth2;
  }, [sensor, ffValue]);

  return isSupport;
};

export default useIsSensorSupportOAuth2;
